/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import { SuccessFetch } from "types";
import { useApi } from "utils";

type ShiftList = {
    mr_shift_name:string,
    description:string,
    mr_shift_id:number,
    in_time:string,
    out_time:string
}

type Response = {
  payload: ShiftList[];
};

export function useShiftList() {
  const api = useApi();
  const [data, setData] = useState<ShiftList[]>([]);
  const [isLoading, setLoading] = useState(false);

  const fetchData = () => {
    setLoading(true);

    api
      .get(`/shift/all`)
      .then((res: SuccessFetch<Response>) => {
        const data = res.data.payload ?? [];
        setData(data);
      })
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  };

  const refetch = () => fetchData();

  useEffect(() => {
    fetchData();

    return () => {
      setData([]);
      setLoading(false);
    };
  }, []);

  return {
    data,
    isLoading,
    refetch,
  };
}
